<input
    type="number"
    class="ag-input-field-input"
    min="0"
    [(ngModel)]="value"
  />
